module.exports = __webpack_public_path__ + "static/media/jb.7abde4d8.png";